//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Searches CmsPages.
 * @param generalSearch (optional) Substring must be in title or url
 * @param searchTitle (optional) 
 * @param searchUrl (optional) 
 * @param showInMenu (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function search(generalSearch?: string | null | undefined, searchTitle?: string | null | undefined, searchUrl?: string | null | undefined, showInMenu?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfCmsPageListItemDto> {
    let url_ = getBaseUrl() + "/api/cms-pages?";
    if (generalSearch !== undefined && generalSearch !== null)
        url_ += "GeneralSearch=" + encodeURIComponent("" + generalSearch) + "&";
    if (searchTitle !== undefined && searchTitle !== null)
        url_ += "SearchTitle=" + encodeURIComponent("" + searchTitle) + "&";
    if (searchUrl !== undefined && searchUrl !== null)
        url_ += "SearchUrl=" + encodeURIComponent("" + searchUrl) + "&";
    if (showInMenu !== undefined && showInMenu !== null)
        url_ += "ShowInMenu=" + encodeURIComponent("" + showInMenu) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearch,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearch?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearch(_response);
    });
}

function processSearch(response: AxiosResponse): Promise<Types.PagedResultOfCmsPageListItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPagedResultOfCmsPageListItemDto(resultData200);
        return Promise.resolve<Types.PagedResultOfCmsPageListItemDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfCmsPageListItemDto>(null as any);
}

/**
 * Creates CmsPage.
 */
export function create(createCmsPageDto: Types.CreateCmsPageDto, config?: AxiosRequestConfig | undefined): Promise<Types.CmsPageDto> {
    let url_ = getBaseUrl() + "/api/cms-pages";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateCmsPageDto(createCmsPageDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.CmsPageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCmsPageDto(resultData200);
        return Promise.resolve<Types.CmsPageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CmsPageDto>(null as any);
}

/**
 * Performs translate action for page.
 * @param language (optional) 
 * @param translateTitle (optional) 
 */
export function translatePage(id: number, content: string, language?: Types.Language | undefined, translateTitle?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CmsPageDto> {
    let url_ = getBaseUrl() + "/api/cms-pages/{id}/translate?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (language === null)
        throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
    if (translateTitle === null)
        throw new Error("The parameter 'translateTitle' cannot be null.");
    else if (translateTitle !== undefined)
        url_ += "translateTitle=" + encodeURIComponent("" + translateTitle) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(content);

    let options_: AxiosRequestConfig = {
        ..._requestConfigTranslatePage,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigTranslatePage?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTranslatePage(_response);
    });
}

function processTranslatePage(response: AxiosResponse): Promise<Types.CmsPageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCmsPageDto(resultData200);
        return Promise.resolve<Types.CmsPageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CmsPageDto>(null as any);
}

/**
 * Gets CMS page details by id.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function getDetailsById(id: number, getActiveVersion?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CmsPageDto> {
    let url_ = getBaseUrl() + "/api/cms-pages/id/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (getActiveVersion === null)
        throw new Error("The parameter 'getActiveVersion' cannot be null.");
    else if (getActiveVersion !== undefined)
        url_ += "getActiveVersion=" + encodeURIComponent("" + getActiveVersion) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDetailsById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDetailsById?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDetailsById(_response);
    });
}

function processGetDetailsById(response: AxiosResponse): Promise<Types.CmsPageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCmsPageDto(resultData200);
        return Promise.resolve<Types.CmsPageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CmsPageDto>(null as any);
}

/**
 * Patch By Id.
 * @param language (optional) 
 * @param isAutosaved (optional) 
 */
export function patchById(id: number, patchCmsPageDto: Types.PatchCmsPageDto, language?: Types.Language | null | undefined, isAutosaved?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CmsPageDto> {
    let url_ = getBaseUrl() + "/api/cms-pages/id/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (language !== undefined && language !== null)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
    if (isAutosaved === null)
        throw new Error("The parameter 'isAutosaved' cannot be null.");
    else if (isAutosaved !== undefined)
        url_ += "isAutosaved=" + encodeURIComponent("" + isAutosaved) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchCmsPageDto(patchCmsPageDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchById,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchById?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchById(_response);
    });
}

function processPatchById(response: AxiosResponse): Promise<Types.CmsPageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCmsPageDto(resultData200);
        return Promise.resolve<Types.CmsPageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CmsPageDto>(null as any);
}

/**
 * Delete By Id.
 */
export function deleteById(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/cms-pages/id/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteById,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteById?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteById(_response);
    });
}

function processDeleteById(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get Inaccessible Published Urls.
 */
export function getInaccessiblePublishedUrls(config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/cms-pages/inaccessible-urls";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetInaccessiblePublishedUrls,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetInaccessiblePublishedUrls?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetInaccessiblePublishedUrls(_response);
    });
}

function processGetInaccessiblePublishedUrls(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

/**
 * Gets CMS page details by URL.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function getDetailsByUrl(url: string, getActiveVersion?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CmsPageDto> {
    let url_ = getBaseUrl() + "/api/cms-pages/{url}?";
    if (url === undefined || url === null)
      throw new Error("The parameter 'url' must be defined.");
    url_ = url_.replace("{url}", encodeURIComponent("" + url));
    if (getActiveVersion === null)
        throw new Error("The parameter 'getActiveVersion' cannot be null.");
    else if (getActiveVersion !== undefined)
        url_ += "getActiveVersion=" + encodeURIComponent("" + getActiveVersion) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDetailsByUrl,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDetailsByUrl?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDetailsByUrl(_response);
    });
}

function processGetDetailsByUrl(response: AxiosResponse): Promise<Types.CmsPageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCmsPageDto(resultData200);
        return Promise.resolve<Types.CmsPageDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CmsPageDto>(null as any);
}
let _requestConfigSearch: Partial<AxiosRequestConfig> | null;
export function getSearchRequestConfig() {
  return _requestConfigSearch;
}
export function setSearchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearch = value;
}
export function patchSearchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearch = patch(_requestConfigSearch ?? {});
}

let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigTranslatePage: Partial<AxiosRequestConfig> | null;
export function getTranslatePageRequestConfig() {
  return _requestConfigTranslatePage;
}
export function setTranslatePageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTranslatePage = value;
}
export function patchTranslatePageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTranslatePage = patch(_requestConfigTranslatePage ?? {});
}

let _requestConfigGetDetailsById: Partial<AxiosRequestConfig> | null;
export function getGetDetailsByIdRequestConfig() {
  return _requestConfigGetDetailsById;
}
export function setGetDetailsByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDetailsById = value;
}
export function patchGetDetailsByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDetailsById = patch(_requestConfigGetDetailsById ?? {});
}

let _requestConfigPatchById: Partial<AxiosRequestConfig> | null;
export function getPatchByIdRequestConfig() {
  return _requestConfigPatchById;
}
export function setPatchByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchById = value;
}
export function patchPatchByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchById = patch(_requestConfigPatchById ?? {});
}

let _requestConfigDeleteById: Partial<AxiosRequestConfig> | null;
export function getDeleteByIdRequestConfig() {
  return _requestConfigDeleteById;
}
export function setDeleteByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteById = value;
}
export function patchDeleteByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteById = patch(_requestConfigDeleteById ?? {});
}

let _requestConfigGetInaccessiblePublishedUrls: Partial<AxiosRequestConfig> | null;
export function getGetInaccessiblePublishedUrlsRequestConfig() {
  return _requestConfigGetInaccessiblePublishedUrls;
}
export function setGetInaccessiblePublishedUrlsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetInaccessiblePublishedUrls = value;
}
export function patchGetInaccessiblePublishedUrlsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetInaccessiblePublishedUrls = patch(_requestConfigGetInaccessiblePublishedUrls ?? {});
}

let _requestConfigGetDetailsByUrl: Partial<AxiosRequestConfig> | null;
export function getGetDetailsByUrlRequestConfig() {
  return _requestConfigGetDetailsByUrl;
}
export function setGetDetailsByUrlRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDetailsByUrl = value;
}
export function patchGetDetailsByUrlRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDetailsByUrl = patch(_requestConfigGetDetailsByUrl ?? {});
}